export const navigations = [
    {
        name: 'Approved appointments list',
        path: '/dashboard/approvedAppointments',
        icon: 'dashboard',
    },
    {
        name: 'Completed appointments list',
        path: '/dashboard/completedAppointments',
        icon: 'dashboard',
    },
    { name: 'Doctor management', path: '/dashboard/doctorlist', icon: 'add' },
    {
        name: 'Role management',
        path: '/dashboard/rolemanagement',
        icon: 'person',
    },
    {
        name: 'Location management',
        path: '/dashboard/location',
        icon: 'place',
    },
    {
        name: 'Privacy policy',
        path: '/dashboard/privacy-policy',
        icon: 'security',
    },
    {
        name: 'Terms and conditions',
        path: '/dashboard/terms-and-conditions',
        icon: 'note_add',
    },
]
